import Content from '../Content/Content'
import { useSelector } from 'react-redux'

export const Watchlist = (props) => {
	const watchlistState = useSelector((state) => state.watchlist)

	return <Content isContentPage={false} currentSection={'mystuff'} gridUrl={watchlistState.url} />
}
export default Watchlist
